/* Shopify3 films: one decoder playing, mobile sources, far-away decoders released. */
(() => {
  const roots = [...document.querySelectorAll('[data-waiting-list-page] .fvs-step-film:not([data-film-ready])')];
  if (!roots.length) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 900px)');
  const films = [];
  let active = null;
  let suspended = false;
  const paths = { pause: 'M8 5v14M16 5v14', play: 'm8 4 12 8-12 8Z', replay: 'M3 10a9 9 0 1 1 1 8M3 3v7h7' };

  function controls(f) {
    const state = f.ended ? 'replay' : f === active ? 'pause' : 'play';
    if (f.controlState !== state) {
      f.controlState = state;
      f.button.innerHTML = `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${paths[state]}"/></svg>`;
      f.button.setAttribute('aria-label', `${f.ended ? 'Rivedi' : f === active ? 'Pausa' : 'Riproduci'} video: step ${f.root.dataset.step}`);
      f.root.dataset.playing = String(f === active);
    }
  }
  const updateControls = () => films.forEach(controls);
  function stop() {
    if (!active) return;
    const previous = active;
    active = null;
    previous.generation++;
    previous.video.pause();
  }
  function release(f) {
    if (!f.video.getAttribute('src')) return;
    if (active === f) stop();
    f.time = Number.isFinite(f.video.currentTime) ? f.video.currentTime : f.time;
    f.generation++;
    f.video.pause();
    f.video.removeAttribute('src');
    f.video.load();
  }
  function start(f) {
    if (suspended || document.hidden) return;
    if (active && active !== f) stop();
    if (!f.video.getAttribute('src')) {
      f.generation++;
      f.video.src = mobile.matches && f.video.dataset.mobileSrc ? f.video.dataset.mobileSrc : f.video.dataset.src;
      f.video.load();
    }
    const generation = ++f.generation;
    active = f;
    f.blocked = false;
    f.video.play().catch(() => {
      // A scroll/release/replay can abort an earlier play without blocking the current one.
      if (generation === f.generation && active === f) {
        active = null;
        f.blocked = true;
        updateControls();
      }
    });
    updateControls();
  }
  function schedule() {
    if (suspended || document.hidden) { stop(); updateControls(); return; }
    if (active && !active.visible) stop();
    if (!active && !reduced.matches) {
      const f = films.find(f => f.visible && !f.paused && !f.ended && !f.blocked);
      if (f) start(f);
    }
    updateControls();
  }
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      const f = films.find(f => f.root === entry.target);
      if (!f) continue;
      const visible = entry.intersectionRatio >= .4;
      if (visible && !f.visible && f.ended && !f.paused) {
        f.time = 0; f.ended = false;
        if (f.video.readyState >= 1) f.video.currentTime = 0;
      }
      f.visible = visible;
    }
    schedule();
  }, { threshold: [0, .4, .8] });
  const resourceObserver = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (entry.isIntersecting) continue;
      const f = films.find(f => f.root === entry.target);
      // Observer callbacks may arrive in either order after a long anchor jump.
      if (f) { f.visible = false; release(f); }
    }
    schedule();
  }, { rootMargin: '600px 0px', threshold: 0 });

  for (const root of roots) {
    const video = root.querySelector('video');
    const button = root.querySelector('.fvs-film-control');
    const chapters = root.querySelector('.fvs-film-chapters');
    if (!video || !button || !chapters) continue;
    video.muted = true; video.playsInline = true;
    const f = { root, video, button, visible: false, paused: false, ended: false, blocked: false, time: 0, generation: 0 };
    films.push(f); root.dataset.filmReady = 'true'; button.hidden = false; chapters.hidden = false;
    const chapterButtons = [...chapters.querySelectorAll('button')];
    function progress() {
      const time = video.currentTime;
      chapterButtons.forEach((b, i) => {
        const from = Number(b.dataset.filmChapter);
        const until = i < chapterButtons.length - 1 ? Number(chapterButtons[i + 1].dataset.filmChapter) : Number(root.dataset.duration);
        b.style.setProperty('--progress', Math.max(0, Math.min(1, (time - from) / (until - from))));
        b.setAttribute('aria-pressed', String(time >= from && time < until));
      });
    }
    video.addEventListener('loadedmetadata', () => {
      if (f.time > 0 && Number.isFinite(video.duration)) video.currentTime = Math.min(f.time, Math.max(0, video.duration - .01));
      progress();
    });
    for (const b of chapterButtons) b.addEventListener('click', () => {
      if (active && active !== f) active.paused = true;
      f.ended = false; f.paused = false; f.time = Number(b.dataset.filmChapter);
      if (video.readyState >= 1) video.currentTime = f.time;
      start(f); progress();
    });
    video.addEventListener('timeupdate', progress); progress();
    button.addEventListener('click', () => {
      if (active === f) { f.paused = true; stop(); }
      else {
        if (active) active.paused = true;
        if (f.ended) { f.time = 0; f.ended = false; if (video.readyState >= 1) video.currentTime = 0; }
        f.paused = false; start(f);
      }
      updateControls();
    });
    video.addEventListener('ended', () => { f.ended = true; if (active === f) active = null; schedule(); });
    video.addEventListener('error', () => {
      if (!video.getAttribute('src')) return;
      f.blocked = true; if (active === f) active = null; schedule();
    });
    observer.observe(root); resourceObserver.observe(root); controls(f);
  }
  reduced.addEventListener('change', () => { if (reduced.matches) stop(); schedule(); });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) { stop(); films.forEach(release); }
    schedule();
  });
  window.addEventListener('pagehide', () => { suspended = true; stop(); films.forEach(release); updateControls(); });
  window.addEventListener('pageshow', () => { suspended = false; schedule(); });
})();
